<template>
  <v-container>
    <!-- Sanckbar para la tabla -->
    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
      top
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-row v-if="modo == 1">
      <v-col>
        <v-card>
          <v-card-title>
            Subseries
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded small @click="nuevaSerie()">Nueva subserie</v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="subseries"
            :search="search"
          >
            
            <template v-slot:item.actions="{ item }">
              <v-btn color="primary" icon @click="editar(item)"><v-icon>edit</v-icon></v-btn>
              <v-btn color="red" icon @click="dialog2 = true, idDelete = item.idsubseries"><v-icon>delete</v-icon></v-btn>
              <v-btn color="primary" icon @click="openCarac(item)"><v-icon>assignment</v-icon></v-btn>
            </template>

          </v-data-table>


        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="modo == 2 || modo == 3">
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title>
            Agregar subserie
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded small @click="modo = 1" class="mr-4">Cancelar</v-btn>
            <v-btn color="primary" rounded small @click="agregar">Agregar</v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" lg="2">
                <v-select 
                  dense
                  outlined
                  :items="series"
                  v-model="serie"
                  :hint="` ${serie.idserie}`"
                  item-text="nomserie"
                  item-value="idserie" 
                  label="Serie"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" lg="2">
                <v-text-field
                  outlined
                  dense
                  label="nombre"
                  v-model="nomsubserie"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="2">
                <v-select 
                  dense
                  outlined
                  :items="categorias"
                  v-model="categoria"
                  item-text="nomcatego"
                  item-value="idcategoria" 
                  label="Categoría"
                  persistent-hint
                  return-object
                  single-line
            ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" md="4">
                <FilePond ref="pond" 
                  v-model="myFiles" 
                  allowMultiple="true" 
                  server="https://support-smipack.com:3000/pdfs2" 
                  @change="verDocumento"/>

                <v-file-input
                  placeholder="Agrega el manual"
                  label="Manual de uso"
                  v-model="docum1"
                ></v-file-input>
              </v-col>
              <v-col cols="2" md="1">
                <v-btn color="primary" icon @click="cargar()"><v-icon>backup</v-icon></v-btn>
              </v-col>
              <v-col cols="10" md="4">
                 <FilePond ref="pond" 
                  v-model="myFiles2" 
                  allowMultiple="true" 
                  server="https://support-smipack.com:3000/pdfs2" 
                  @change="verDocumento"/>

                <v-file-input
                  placeholder="Agrega el Diagrama de partes"
                  label="Diagrama de partes"
                  v-model="docum2"
                ></v-file-input>
              </v-col>
              <v-col cols="2" md="1">
                <v-btn color="primary" icon @click="cargar2()"><v-icon>backup</v-icon></v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="10" md="4">
                <iframe :src="documurl1" width="100%" height="500" v-if="documurl1"></iframe>
              </v-col>
              
              <v-col cols="10" md="4">
                <iframe :src="documurl2" width="100%" height="500" v-if="documurl2"></iframe>
              </v-col>
            </v-row>
          </v-card-text>    
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Subserie</v-card-title>
          <v-card-text>¿Estas seguro que deseas eliminar la subserie?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog2 = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteItem">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog
        persistent
        v-model="caracteristicas"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        
        <v-card>
          <v-toolbar
            dark
            color="primary"
            >
            <v-btn
              icon
              dark
              @click="caracteristicas = false, limpiar()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Características</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="addCaracteristicas()"
              >
                Guardar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-tabs
            dense
            class="mt-4"
            v-model="tab"
            align-with-title
          >
            <v-tabs-slider color="grey"></v-tabs-slider>

            <v-tab
              v-for="(item,i) in items"
              :key="i"
            >
              <v-icon v-text="item.icon" left></v-icon>{{ item.name }}
            </v-tab>
          </v-tabs>

          <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
          <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
          <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="8" lg="6" class="py-0">
                      <v-card class="elevation-0">
                        <v-card-title primary-title class="py-0">
                          Resumen
                        </v-card-title>
                      </v-card>
                      <v-textarea
                        v-model="resumen"
                        outlined
                        label="Resumen"
                      >
                      </v-textarea>
                    </v-col>

                    <v-col cols="12" sm="4" lg="4" class="py-0">
                      <v-card class="elevation-0">
                        <v-card-title primary-title class="py-0">
                          Selecciona una subserie a copiar
                        </v-card-title>
                      </v-card>
                      <v-select
                        outlined
                        :items="subseriescopi"
                        v-model="subseriecopi"
                        label="Subserie a copiar"
                        return-object
                        item-text="nomsubserie"
                        item-value="idsubserie" 
                        single-line
                        hide-details
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    
                  </v-row>
                  <v-divider></v-divider>

                  <v-row class="py-0">
                    <v-col cols="12" sm="8" lg="6" class="py-0">
                      <v-card class="elevation-0">
                        <v-card-title primary-title class="py-0">
                          Características
                        </v-card-title>
                      </v-card>
                      <v-data-table
                        :headers="headers2"
                        :items="tabla"
                        class="elevation-0"
                        hide-default-footer
                        :items-per-page="11"
                      >
                        <template v-slot:item.valor="props">
                          <v-edit-dialog
                            :return-value.sync="props.item.name"
                            @save="save"
                            @cancel="cancel"
                            @open="open"
                            @close="save"
                          >
                            {{ props.item.valor }}
                            <template v-slot:input>
                              <v-textarea
                                v-model="props.item.valor"
                                label="Edit"
                              >
                              </v-textarea>
                              <!-- <v-text-field
                                v-model="props.item.valor"
                                label="Edit"
                                single-line
                                counter
                              ></v-text-field> -->
                            </template>
                          </v-edit-dialog>
                        </template>

                      </v-data-table>
                    </v-col>
                  
                    <v-col cols="12" sm="8" lg="6">
                      <v-card class="elevation-0">
                        <v-card-title primary-title>
                          Subir PDF
                        </v-card-title>
                      </v-card>
                      <v-card class="elevation-10">
                        <FilePond ref="pond" 
                          v-model="myFiles3" 
                          allowMultiple="true" 
                          server="https://support-smipack.com:3000/pdfs2" 
                          @change="verDocumento2"/>
                      </v-card>
                      <v-row>
                        <v-col>
                          <iframe :src="documurl3" width="100%" height="350" v-if="documurl3"></iframe>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-tab-item>



            <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
            <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
            <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row >
                    <v-col cols="12" sm="8" lg="4">
                      <v-card-title primary-title>
                        Cargar Imagen
                      </v-card-title>

                      <FilePond ref="pond" 
                        v-model="filesFoto" 
                        allowMultiple="true" 
                        server="https://support-smipack.com:3000/imagenes2" 
                        @change="cargar()"/>


                      <v-file-input
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Agrega una imagen"
                        prepend-icon="mdi-camera"
                        label="Imagen de operación"
                        @change="cargar()"
                        v-model="filesFoto"
                      ></v-file-input>
                      <v-card-text>
                        <v-img :src="url + imagename" contain width="100%" max-height="350" v-if="imagename!= ''"/>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

          
        </v-card>
      </v-dialog>
    </v-row>


  </v-container>
</template>

<script>
  import vueFilePond from 'vue-filepond';
  import 'filepond/dist/filepond.min.css';

  import 'filepond/dist/filepond.min.css';
  const FilePond = vueFilePond();

  import mixinsSerie from '@/mixins/mixinsSerie.js'
  export default {
    components:{
      FilePond: vueFilePond()
    },
    mixins:[mixinsSerie],
    data () {
      return {
        idsubserieCarac:0,
        caracteristicas: false,
        tab: null,
        items: [
          {name:'Características', icon:'assignment', value: 1}, {name:'Operación', icon:'collections', value: 2}],
        files:[],
        resumen:'',
        myFiles3:[],
        headers2: [
          {
            text: 'Especificaciones tecnicas',
            align: 'start',
            sortable: false,
            value: 'et',
          },
          { text: 'Valor', value: 'valor' },
        ],
        docum3:[],
        documurl3:'',
        filesFoto:[],
        url:'',
        foto:'',
        imagename:'',
        formdata:'',
        modoCarac:0,
        pdfname:'',


        snack: false,
        snackColor: '',
        snackText: '',


        tabla:[
          {et:'Suministro eléctrico', valor: ''},
          {et:'Potencia electrica', valor: ''},
          {et:'Presión del aire comprimido', valor: ''},
          {et:'Consumo del aire comprimido', valor: ''},
          {et:'Barra soldadora', valor: ''},
          {et:'Altura máxima del paquete', valor: ''},
          {et:'Velocidad cintas transportadoras', valor: ''},
          {et:'Producción de hasta', valor: ''},
          {et:'Dimensiones máximas bobina film', valor: ''},
          {et:'Dimensiones de la máquina', valor: ''},
          {et:'Peso neto de la maquina', valor: ''},
        ],


        myFiles:[],
        myFiles2:[],

        dialog2: false,
        idDelete:0,

        idsubserie:'',
        series:[],
        serie:{idserie: '', nomserie:''},

        docum1:[],
        docum2:[],
        documurl1:'',
        documurl2:'',

        nomsubserie:'',

        modo:1,
        search: '',
        headers: [
          {
            text: 'Subserie',
            align: 'start',
            sortable: false,
            value: 'nomsubserie',
          },
          { text: 'Serie', value: 'nomserie' },
          { text: 'Manual', value: 'docum1' },
          { text: 'D. de partes', value: 'docum2' },
          { text: 'Editar', value: 'actions' },
        ],

        subseries:[],

        categorias:[],
        categoria: {idcategoria:'', nomcatego:''},
        
        // copiar esto a otra subserie
        subseriescopi:[],
        subseriecopi:{},
      }
    },

    watch:{
      myFiles(){
        if(this.myFiles[0].serverId != null){
          this.documurl1 = this.$http.options.root + 'pdfs/' + this.myFiles[0].file.name
          this.docum1 = this.myFiles[0].file
          console.log(this.docum1)
        }
      },

      myFiles2(){
        if(this.myFiles2[0].serverId != null){
          this.documurl2 = this.$http.options.root + 'pdfs/' + this.myFiles2[0].file.name
          this.docum2 = this.myFiles2[0].file
          console.log(this.docum1)
        }
      },

      myFiles3(){
        if(this.myFiles3[0].serverId != null){
          this.documurl3 = this.$http.options.root + 'pdfs/' + this.myFiles3[0].file.name
          this.docum3 = this.myFiles3[0].file
          this.pdfname = this.myFiles3[0].file.name
          console.log('documento3',this.docum3)
        }
        console.log('algo esta pasando aquí',this.myFiles3)
      },

      filesFoto(){
        if(this.filesFoto[0].serverId != null){
          this.documurl3 = this.url + this.filesFoto[0].file.name
          this.imagename = this.filesFoto[0].file.name
          console.log('documento3',this.imagename)
        }
      },

      subseriecopi(){
        this.limpiar()
        this.openCarac2(this.subseriecopi)
      }
    },

    created(){
      this.url = this.$http.options.root + 'fotos/'
      this.subseries = []
      this.getSeries()
      this.getSubseries()
      this.getCategorias()
    },

    // watch:{
    //   subseriecopi(){
    //     this.limpiar()
    //     this.openCarac2(this.subseriecopi)
    //   }
    // },

    methods:{
      verDocumento(){
        this.myFiles  = this.$refs.pond.getFiles();
        console.log(this.myFiles[0].file)
      },

      verDocumento2(){
        console.log('documento cargando',verDocumento2)
        this.myFiles3  = this.$refs.pond.getFiles();
        console.log('ver docum3',this.myFiles3[0].file)
      },

      agregar(){
        var payload = {
          nomsubserie: this.nomsubserie,
          idserie: this.serie.idserie,
          estatus: 1,
          docum1: this.docum1.name,
          docum2: this.docum2.name,
          idcategoria: this.categoria.idcategoria
        }

        console.log(payload)

        if(this.modo == 2){
          this.$http.post('clasificacion.subserie.add',payload).then(response=>{
            this.getSubseries()
            this.modo = 1
            this.nomsubserie =''
            this.docum1 =[]
            this.docum2 =[]
          }).catch(error=>{console.log(error)})
        }else{
          this.$http.put('clasificacion.subserie.update/' + this.idsubserie, payload).then(response=>{
            this.getSubseries()
            this.modo = 1
            this.nomsubserie =''
            this.docum1 =[]
            this.docum2 =[]
          }).catch(error=>{console.log(error)})
        }
      },

      cargar(){
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file', this.docum1);
        this.$http.post('pdfs', formData).then(response=>{
          this.documurl1 = this.$http.options.root + 'pdfs/' + this.docum1.name
        }).catch(error=>{console.log(error)})

      },

      getCategorias(){
        this.$http.get('clasificacion.categorias').then(response=>{
          this.categorias = response.body
        }).catch(error=>{console.log(error)})
      },

      cargar2(){
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file', this.docum2);
        this.$http.post('pdfs', formData).then(response=>{
          this.documurl2 = this.$http.options.root + 'pdfs/' + this.docum2.name
        }).catch(error=>{console.log(error)})
      },

      editar(item){
        console.log(item)
        this.modo = 3
        this.nomsubserie = item.nomsubserie
        this.idsubserie = item.idsubseries
        this.serie = {idserie: item.idserie, nomserie: item.nomserie}
        this.documurl1 = 'https://support-smipack.com/pdf/'+ item.docum1
        this.documurl2 = 'https://support-smipack.com/pdf/'+ item.docum2
        this.docum1 = {name: item.docum1}
        this.docum2 = {name: item.docum2}
        this.categoria = {idcategoria: item.idcategoria, nomcatego: item.nomcatego}
        console.log(this.categoria)
      },

      nuevaSerie(){
        this.nomsubserie = ''
        this.idsubserie = ''
        this.serie = {idserie: '', nomserie: ''}
        this.documurl1 = ''
        this.documurl2 = ''
        this.docum1 = {name: ''}
        this.docum2 = {name: ''}
        this.modo = 2
      },

      deleteItem(){
        this.$http.delete('clasificacion.subserie.delete/' + this.idDelete).then(response=>{
          this.getSubseries()
          this.dialog2 = false
        }).catch(error=>console.log(error))
      },

      openCarac(item){
        this.idsubserieCarac = item.idsubseries
        this.caracteristicas = true
        this.$http.get('clasificacion.categoria.subseries.caracteristicas/' + this.idsubserieCarac).then(response=>{
          console.log(response.body)
          if(response.body != ''){
            this.modoCarac = 1
            this.resumen   = response.body.resumen
            this.documurl3 = this.$http.options.root + 'pdfs/' + response.body.pdfname
            this.pdfname = response.body.pdfname
            this.imagename = response.body.imagename
            this.tabla[0].valor = response.body.op1
            this.tabla[1].valor = response.body.op2
            this.tabla[2].valor = response.body.op3
            this.tabla[3].valor = response.body.op4
            this.tabla[4].valor = response.body.op5
            this.tabla[5].valor = response.body.op6
            this.tabla[6].valor = response.body.op7
            this.tabla[7].valor = response.body.op8
            this.tabla[8].valor = response.body.op9
            this.tabla[9].valor = response.body.op10
            this.tabla[10].valor = response.body.op11   
          }else{this.modoCarac = 2}
        }).catch(error=>console.log(error))
      },

      openCarac2(item){
        // this.idsubserieCarac = item.idsubseries
        this.caracteristicas = true
        this.$http.get('clasificacion.categoria.subseries.caracteristicas/' + item.idsubseries).then(response=>{
          console.log(response.body)
          if(response.body != ''){
            this.resumen   = response.body.resumen
            this.documurl3 = this.$http.options.root + 'pdfs/' + response.body.pdfname
            this.pdfname = response.body.pdfname
            this.imagename = response.body.imagename
            this.tabla[0].valor = response.body.op1
            this.tabla[1].valor = response.body.op2
            this.tabla[2].valor = response.body.op3
            this.tabla[3].valor = response.body.op4
            this.tabla[4].valor = response.body.op5
            this.tabla[5].valor = response.body.op6
            this.tabla[6].valor = response.body.op7
            this.tabla[7].valor = response.body.op8
            this.tabla[8].valor = response.body.op9
            this.tabla[9].valor = response.body.op10
            this.tabla[10].valor = response.body.op11   
          }
        }).catch(error=>console.log(error))
      },

      addCaracteristicas(){
        console.log(this.$refs.pond.getFiles())
        var payload = {
          idsubseries: this.idsubserieCarac,
          resumen: this.resumen,
          imagename: this.imagename,
          pdfname: this.pdfname,
          op1: this.tabla[0].valor,
          op2: this.tabla[1].valor,
          op3: this.tabla[2].valor,
          op4: this.tabla[3].valor,
          op5: this.tabla[4].valor,
          op6: this.tabla[5].valor,
          op7: this.tabla[6].valor,
          op8: this.tabla[7].valor,
          op9: this.tabla[8].valor,
          op10: this.tabla[9].valor,
          op11: this.tabla[10].valor
        }
        if(this.modoCarac == 2){
          this.$http.post('clasificacion.categoria.subseries.caracteristicas', payload).then(response=>{
            this.snack = true
            this.snackColor = 'success'
            this.snackText = 'Datos guardados'
            this.limpiar()
          }).catch(error=>console.log(error))
        }else{
          this.$http.put('clasificacion.categoria.subseries.caracteristicas/' + this.idsubserieCarac, payload).then(response=>{
            console.log(response.body)
            this.snack = true
            this.snackColor = 'success'
            this.snackText = 'Datos actualizados'
            this.limpiar()
          }).catch(error=>console.log(error))
        }
      },

      limpiar(){
        this.caracteristicas = false
        this.resumen   = ''
        this.pdfname   = ''
        this.imagename = ''
        this.tabla[0].valor = ''
        this.tabla[1].valor = ''
        this.tabla[2].valor = ''
        this.tabla[3].valor = ''
        this.tabla[4].valor = ''
        this.tabla[5].valor = ''
        this.tabla[6].valor = ''
        this.tabla[7].valor = ''
        this.tabla[8].valor = ''
        this.tabla[9].valor = ''
        this.tabla[10].valor = ''
        this.documurl3 = ''
        this.docum3 = ''
        this.imagename = ''
        this.foto = ''
        this.filesFoto = []
        this.formdata = ''
      },

      save () {
        // this.snack = true
        this.snackColor = 'success'
        this.snackText = '´Datos guardados'
      },
      cancel () {
        // this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Cancel'
      },
      open () {
        // this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Abrir dialogo'
      },

      cargar(){
        // creamos una variable tipo FormData
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file', this.filesFoto);
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(this.filesFoto, formData)
        this.imagename = this.filesFoto.name
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          me.foto = reader.result
          me.formdata = formData
        };
      },
      

    }
  }
</script>